import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=6a98ede4&scoped=true&"
import script from "./AboutView.vue?vue&type=script&lang=js&"
export * from "./AboutView.vue?vue&type=script&lang=js&"
import style0 from "@/resources/styles/about.css?vue&type=style&index=0&id=6a98ede4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a98ede4",
  null
  
)

export default component.exports